module.exports = __webpack_public_path__ + "img/cb-l-r1.c45097d0.gif";